import gql from 'graphql-tag';
export const configuracionSistema = gql`
  query configuracionContendientes23{
    configuracionContendientes23 {
      Oid
      ActualizacionAl
      ActualizacionRenunciasAl
      MostrarMenuRenuncias
    }
  }
`;

export const listaContendientes = gql`
  query listaContendientes($skip: Boolean!) {
    allContendientes23 {
      Oid
      NombreDiputado
      Numero @skip(if: $skip)
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      ArchivoB64
      Enlace
      Notas
      NotaLicencia
      SFTPDocumento1
      SFTPDocumento2
      ReeleccionPrevia
      ReeleccionesLegilatura
    }
  }
`;
export const listaContendientesRenuncia = gql`
  query listaContendientes($skip: Boolean!) {
    allContendientesRenuncia23 {
      Id
      Oid
      NombreDiputado
      Numero @skip(if: $skip)
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      ArchivoB64
      Enlace
      Notas
      Lista
      ContendienteActivo
      Renuncia
      Licencia
      Funciones
      Documento1
      Documento2
      Documento3
      SFTPDocumento2
      SFTPDocumento1
      NotaLicencia
    }
  }
`;
export const listaContendientesLicencia = gql`
  query listaContendientes($skip: Boolean!) {
    allContendientesLicencia23 {
      Oid
      NombreDiputado
      Numero @skip(if: $skip)
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      ArchivoB64
      Enlace
      Notas
      NotaLicencia
    }
  }
`;
export const listaContendientesFunciones = gql`
  query listaContendientes($skip: Boolean!) {
    allContendientesFunciones23 {
      Oid
      NombreDiputado
      Numero @skip(if: $skip)
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      ArchivoB64
      Enlace
      Notas
      NotaLicencia
    }
  }
`;
export const contendiente = gql`
  query getContendiente($oid: String) {
    getContendiente23(Oid: $oid) {
      NombreDiputado
      Enlace
      Numero
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      Notas
      ArchivoB64
      ArchivoB641
      ArchivoB642
      ArchivoB643
      NotaLicencia
    }
  }
`;
export const filteredContendientes = gql`
  query filterContendientes($keyWord: String) {
    filterContendientes23(KeyWord: $keyWord) {
      Oid
      NombreDiputado
      Enlace
      Numero
      FechaRecepcion
      EntidadFederativa
      CorreoFisico
      Hora
      Folio
      GrupoParlamentario
      DistritoCircuns
      Tipo
      NombreArchivo
      TipoEleccion
      EnFunciones
      Notas
      ArchivoB64 @skip(if: true)
      NotaLicencia
    }
  }
`;
export const getallDocumentosAcuerdos_ReeleccionConsecutiva = gql`
  query allDocumentosAcuerdos_ReeleccionConsecutiva {
    allDocumentosAcuerdos_ReeleccionConsecutiva23 {
      Oid
      Nombre
      Orden
      UrlImagen
      UrlArchivo
      Descripcion
    }
  }
`;
